const subscribers = new Set();

/** subscribeToMessages allows components to subscribe to message notifications.
 * When a new message is received,
 * all subscribed callbacks will be called with the message data.
 * * @param {Function} callback - The function to call when a new message is received.
 * @returns {Function} A function to unsubscribe from message notifications.
 */
export const subscribeToMessages = (callback) => {
    subscribers.add(callback);
    return () => subscribers.delete(callback); // Unsubscribe
};

/** * notifyMessage notifies all subscribers with the new message data.
 * This function is called when a new message is received from the WebSocket.
 * @param {Object} message - The message data to notify subscribers with.
 */
export const notifyMessage = (message) => {
    for (const callback of subscribers) {
        callback(message);
    }
};
